import { MapStore } from '@deqo/foundation';
import { injectable } from 'inversify';
import { Net } from './Net';

@injectable()
export class NetRegister extends MapStore<string, Net> {

    public delete(key: string) {
        this.updateState(s => void (s.delete(key)));
    }

    public set(key: string, value: Net) {
        this.updateState(s => s.set(key, value));
        return this;
    }
}
